import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { httpBatchLink } from "@trpc/client";
import { useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import superjson from "superjson";
import { TRPC_URL } from "./lib/config.ts";
import { trpc } from "./lib/trpc.ts";
import { DevCanvasRoute } from "./routes/dev-canvas.tsx";
import { LocalCanvasRoute } from "./routes/local-canvas.tsx";
import { LoginRoute } from "./routes/login.tsx";
import { OrganizationsRoute } from "./routes/organizations.tsx";
import { EditorRoute } from "./routes/editor.tsx";
import { RequireAuth } from "./routes/require-auth.tsx";
import { Shell } from "./routes/shell.tsx";

export function App() {
  const [queryClient] = useState(() => new QueryClient());
  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [
        httpBatchLink({
          url: TRPC_URL,
          fetch: (url, opts) =>
            fetch(url, { ...opts, credentials: "include" }),
          transformer: superjson,
        }),
      ],
    }),
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/local" element={<LocalCanvasRoute />} />
            <Route path="/local/:documentId" element={<LocalCanvasRoute />} />
            {import.meta.env.DEV ? (
              <Route path="/dev/canvas" element={<DevCanvasRoute />} />
            ) : null}
            <Route
              element={
                <RequireAuth>
                  <Shell />
                </RequireAuth>
              }
            >
              <Route index element={<Navigate to="/organizations" replace />} />
              <Route path="organizations" element={<OrganizationsRoute />} />
              <Route path="editor/:documentId" element={<EditorRoute />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </trpc.Provider>
  );
}
